function SentinelVisitsView(sentinelService, filterService) {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            visitCallback: "=",
            visits: "=",
            visitType: "="
        },
		template: require('./visits-view.html'),
		
        link: function (scope) {
            scope.siteVisits = [];
            scope.masterDisplayOptions = filterService.getMasterDisplayOptions();
            // Page State Vars (driven by visitType)
            if (scope.visitType === "check-in") scope.tableTitle = "Registered Guests";
            if (scope.visitType === "check-out") scope.tableTitle = "Currently Checked-In";
            if (scope.visitType === "visits") scope.tableTitle = "All Visits";

            function applyFilters(visits) {
                if (!(visits instanceof Array)) return;

                if (scope.visitType === "visits")    scope.siteVisits = [].concat(visits);
                if (scope.visitType === "check-in")  scope.siteVisits = filterService.filterRegisteredGuests(visits);
                if (scope.visitType === "check-out") scope.siteVisits = filterService.filterActiveOnly(visits);
            }

            (function () {
                scope.$watch('visits', applyFilters, true);
            })();
        }
    }
}

angular.module('sentinel').directive('sentinelVisitsView', ['sentinelService', 'sentinelUiFilterService', SentinelVisitsView]);